/* eslint-disable @department-of-veterans-affairs/prefer-button-component */
import React from 'react';
import PropTypes from 'prop-types';
import { signInWithSmartCard, SMART_CARD_CSP_TYPE } from '../utilities';

export default function SmartCardLoginButton({ actionLocation = 'usip' }) {
  return (
    <div className="vads-u-margin-bottom--2">
      <button
        type="button"
        data-dd-action-name={`${SMART_CARD_CSP_TYPE}-signin-button-${actionLocation}`}
        className="usa-button vads-u-margin-y--1p5 vads-u-padding-y--2"
        onClick={signInWithSmartCard}
      >
        <va-icon
          icon="identification"
          size="2"
          style={{ marginRight: '0.25rem' }}
        />
        {` VA PIV Card`}
      </button>
    </div>
  );
}

SmartCardLoginButton.propTypes = {
  actionLocation: PropTypes.string,
};
